import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.tick = this.tick.bind(this);
  }
  componentDidMount() {
    if (this.props.timeout && this.props.enabled) {
      this.intervalID = setInterval(() => this.tick(), this.props.timeout);
    }
  }
  componentWillUnmount() {
    if (this.intervalID) {
      clearInterval(this.intervalID);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.timeout && nextProps.enabled) {
      if (this.intervalID) {
        clearInterval(this.intervalID);
      }
      this.intervalID = setInterval(() => this.tick(), nextProps.timeout);
    } else if (this.intervalID) {
      clearInterval(this.intervalID);
    }
  }

  tick() {
    this.props.callback();
  }

  render() {
    return null;
  }
}

Timer.propTypes = {
  timeout: PropTypes.number,
  enabled: PropTypes.bool,
  callback: PropTypes.func,
};
Timer.defaultProps = {
  timeout: 1000,
  enabled: false,
  enabled: () => {},
};
export default Timer;
